import * as React from 'react';

/**
 * `value`, once it has stopped changing for `delay` milliseconds.
 *
 * For the inputs that turn into a request: a search box, a slug suggestion, a
 * live count. Without it every keystroke is a request, and the screens that
 * wrote their own `setTimeout` each wrote it slightly differently.
 */
export function useDebouncedValue<T>(value: T, delay = 300): T {
  const [debounced, setDebounced] = React.useState(value);

  React.useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delay);
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debounced;
}
